import { APIMethod, fetchData } from "@client";

export async function checkTemplateCommentsQuery(templateUuid) {
  const res = await fetchData(`/v1/ws/template/comments/has/${templateUuid}`,
    APIMethod.GET,
  );
  return res?.hasComments;
}
